import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { FaTimes, FaPaperPlane, FaSmile } from 'react-icons/fa';
import styles from './publish.module.css';
import { API_URL } from '../Utils/api';

const CreateTextPost = ({ back }) => {
    const [text, setText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [toast, setToast] = useState(null);

    const MAX_CHARS = 500;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!text.trim() || isLoading) return;

        setIsLoading(true);
        try {
            const token = localStorage.getItem('token');
            await axios.post(
                `${API_URL}/publication`,
                { postText: text.trim(), postType: 'regular' },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setToast('Publié avec succès !');
            setTimeout(() => back(), 1000);
        } catch (error) {
            setToast(error.response?.data?.message || 'Erreur lors de la publication');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (toast) {
            const timer = setTimeout(() => setToast(null), 3000);
            return () => clearTimeout(timer);
        }
    }, [toast]);

    return (
        <div className={styles.container}>
            {toast && <div className={styles.toast}>{toast}</div>}

            <header className={styles.header}>
                <button type="button" onClick={back} className={styles.closeBtn} aria-label="Fermer">
                    <FaTimes />
                </button>
                <h1 className={styles.title}>Créer une publication</h1>
                <div className={styles.placeholder}></div>
            </header>

            <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.scrollContent}>
                    <div className={styles.section}>
                        <textarea
                            className={`${styles.input} ${styles.textarea}`}
                            placeholder="Quoi de neuf ?"
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            maxLength={MAX_CHARS}
                            rows={8}
                            autoFocus
                        />
                        <span className={styles.charCount}>
                            {text.length}/{MAX_CHARS}
                        </span>
                    </div>
                </div>

                <footer className={styles.footer}>
                    <button
                        type="submit"
                        className={`${styles.submitBtn} ${(!text.trim() || isLoading) ? styles.submitBtnDisabled : ''}`}
                        disabled={!text.trim() || isLoading}
                    >
                        {isLoading ? <div className={styles.spinner} /> : (
                            <>
                                <span>Publier</span>
                            </>
                        )}
                    </button>
                </footer>
            </form>
        </div>
    );
};

export default CreateTextPost;
